var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8"},[_c('div',[_c('h3',{staticClass:"text-lg font-bold leading-6 text-gray-900"},[_vm._v("Data | Kasir")])])])
}]

export { render, staticRenderFns }